/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Preview_Wiki_DescInputs */

const en_mk_preview_wiki_desc = /** @type {(inputs: Mk_Preview_Wiki_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keep project summaries and synced context so your team and agent share a reference.`)
};

const id_mk_preview_wiki_desc = /** @type {(inputs: Mk_Preview_Wiki_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Simpan ringkasan proyek dan hasil sinkronisasi agar tim dan agent punya acuan yang sama.`)
};

/**
* | output |
* | --- |
* | "Keep project summaries and synced context so your team and agent share a reference." |
*
* @param {Mk_Preview_Wiki_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_preview_wiki_desc = /** @type {((inputs?: Mk_Preview_Wiki_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Preview_Wiki_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_preview_wiki_desc(inputs)
	return en_mk_preview_wiki_desc(inputs)
});